import { render, staticRenderFns } from "./ZendeskChannels.vue?vue&type=template&id=c4c7bb4c&scoped=true"
import script from "./ZendeskChannels.vue?vue&type=script&lang=js"
export * from "./ZendeskChannels.vue?vue&type=script&lang=js"
import style0 from "./ZendeskChannels.vue?vue&type=style&index=0&id=c4c7bb4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c7bb4c",
  null
  
)

export default component.exports